import { AfterViewInit, Directive } from '@angular/core';
import { MatDateFormats } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { DateService } from './date.service';
import * as moment from 'moment';
import { WebviewService } from '@app/services/webview.service';
import { Store } from '@ngxs/store';
import { SettingSelectors } from '@app/store/setting/setting.selectors';
import { Era } from '@app/models/date.model';

export const CUSTOM_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'l',
  },
  display: {
    dateInput: 'YYYY年MMMD日',
    monthYearLabel: 'YYYY年MMM',
    dateA11yLabel: 'YYYY年MMMD日',
    monthYearA11yLabel: 'YYYY年MMM',
  },
};

export class DatepickerSettingModel {
  findEraYear(date: Date, eras: Era[]) {
    return eras.find((era) =>
      new Date(era.start_year, era.start_month - 1, era.start_day).getTime() <= date.getTime());
  }

  findYearByEra(eraNm: string, eras: Era[]) {
    return eras.find((era) => era.name === eraNm);
  }

  isLessThan(checkDate: Date) {
    const minLimit = new Date(1868, 8, 8);
    return minLimit.getTime() > checkDate.getTime();
  }

  isGreaterThan(checkDate: Date) {
    const maxLimit = new Date(2117, 11, 31);
    return maxLimit.getTime() < checkDate.getTime();
  }
}


@Directive({
  selector: '[kidspicker]',
})
export class KidsPicker implements AfterViewInit {
  constructor(
    private store: Store,
    private webviewService: WebviewService,
    private dateService: DateService,
    private picker: MatDatepicker<any>) {
  }

  ngAfterViewInit(): void {
    this.picker.openedStream.subscribe(() => {

      const isWebview = this.store.selectSnapshot(SettingSelectors.isWebView);
      if (isWebview) {
        this.webviewService.triggerWebView();
      }

      setTimeout(() => {
        this.dateService.startMode = this.picker.startView;
        let prevBtn = document.getElementsByClassName('mat-calendar-previous-button')[0];
        let nextBtn = document.getElementsByClassName('mat-calendar-next-button')[0];
        this.initTodayButton();
        if (prevBtn) {
          prevBtn.addEventListener('click', () => {
            this.dateService.castYear();
            ;
          })
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', () => {
            this.dateService.castYear();
          })
        }
      }, 200);
    });
    this.picker.viewChanged.subscribe((_view) => {
      this.dateService.startMode = _view;
      this.dateService.castYear();
    });
  }

  initTodayButton() {
    let body = document.getElementsByClassName('mat-datepicker-content-container')[0];
    //body.style.height = body.getBoundingClientRect().height + 12;
    let nowButton = document.createElement("button");
    nowButton.addEventListener('click', () => {
      this.picker.select(moment());
      this.picker.close();
    })
    nowButton.innerText = '本日';
    nowButton.style.width = '3.75rem';
    nowButton.style.padding = '12px 14px';
    nowButton.style.border = '1px solid #949494';
    nowButton.style.borderRadius = '8px';
    nowButton.style.margin = '0 12px';
    nowButton.style.fontSize = '12px';
    nowButton.style.lineHeight = '12px';
    nowButton.style.position = 'absolute';
    nowButton.style.bottom = '1%';
    nowButton.style.background = '#fff';
    body.appendChild(nowButton);
  }
}
